import dayjs from 'dayjs';
import { UserDTO } from './user.dto';

export interface ICreneauGardiennageImported {
  id: string;
  debut: Date;
  fin: Date;
  agent?: UserDTO;
}

export class CreneauGardiennageImported implements ICreneauGardiennageImported {
  constructor(
    public id: string,
    public debut: Date,
    public fin: Date,
    public agent?: UserDTO
  ) {}

  public static hydrate(obj: ICreneauGardiennageImported): ICreneauGardiennageImported {
    return new CreneauGardiennageImported(
      obj.id,
      dayjs(obj.debut).toDate(),
      dayjs(obj.fin).toDate(),
      obj.agent ? UserDTO.hydrate(obj.agent) : undefined
    );
  }
}
